// src/features/medicine-inventory/pages/Medicines.jsx
import React from 'react';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';
import MedicineList from '../components/medicines/MedicineList';

const Medicines = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* <Navbar /> */}
      <div className="flex">
        {/* <Sidebar /> */}
        <main className="flex-1 p-6">
          <MedicineList />
        </main>
      </div>
    </div>
  );
};

export default Medicines;